import React, { Fragment, useEffect, useState } from 'react';
import { FnAxios, Convert, undefinedOrNull, I18n} from "utilities/utilities";
import { ApiLeave } from "enum/api";
import { Card, Grid, Typography } from '@mui/material';
import usePagination from 'components/Pagination/Pagination';
import { Pagination, Stack, } from '@mui/material';
import PaginationItem from "@mui/material/PaginationItem";
import AccordionCustom from 'components/Accordion';
import { EnumColorStatusHistory } from 'enum/enum';
import "../Leave.css";
export interface IPropsLogHistory{
    nRefID: number;
    nMode: number;
}

const LogHistory = (props: IPropsLogHistory) => {
    const AxiosFn = FnAxios();
    const [nRefID, setnRefID] = useState(null);
    const [lstDetailsLogHistory, setlstDetailsLogHistory] = useState([]);
    // const [lstDetailsLogHistory, setlstDetailsLogHistory] = useState([
    //     {
    //         nLogID: 1,
    //         sTitle : "วันที่ 25/08/2023 เวลา 11.20 น. ดำเนินการ ส่งคำขอ โดย ชื่อคนที่ขอลา (ตำแหน่ง)",
    //         sDetail: "ssssssssssssss",
    //         sColor: "#AEE2FF",
    //     },
    //     {
    //         nLogID: 2,
    //         sTitle : "วันที่ 25/08/2023 เวลา 11.20 น. ดำเนินการ ส่งกลับแก้ไข โดย ชื่อคนอนุมัติ (ตำแหน่ง)",
    //         sDetail: "ssssssssssssss",
    //         sColor: "#FFDCA9",
    //     },
    //     {
    //         nLogID: 3,
    //         sTitle : "วันที่ 25/08/2023 เวลา 11.20 น. ดำเนินการ อนุมัติ โดย ชื่อคนอนุมัติ (ตำแหน่ง)",
    //         sDetail: "ssssssssssssss",
    //         sColor: "#BCE29E",
    //     },
    //     {
    //         nLogID: 4,
    //         sTitle : "วันที่ 28/08/2023 เวลา 11.20 น. ดำเนินการ ยกเลิกคำขอ โดย แสดงชื่อผู้ที่ยกเลิกคำขอ (ตำแหน่ง)",
    //         sDetail: " - ",
    //         sColor: "#FF9F9F",
    //     },  
    //     {
    //         nLogID: 5,
    //         sTitle : "วันที่ 25/08/2023 เวลา 11.20 น. ดำเนินการ ไม่อนุมัติ โดย ชื่อคนที่ขอลา (ตำแหน่ง)",
    //         sDetail: "ssssssssssssss",
    //         sColor: "#D0BFFF",
    //     },        
    //     {
    //         nLogID: 6,
    //         sTitle : "วันที่ 28/08/2023 เวลา 11.20 น. ดำเนินการ ยกเลิกคำขอ โดย แสดงชื่อผู้ที่ยกเลิกคำขอ (ตำแหน่ง)",
    //         sDetail: " - ",
    //         sColor: "#FF9F9F",
    //     }, 
    //     {
    //         nLogID: 7,
    //         sTitle : "วันที่ 25/08/2023 เวลา 11.20 น. ดำเนินการ ส่งกลับแก้ไข โดย ชื่อคนที่ขอลา (ตำแหน่ง)",
    //         sDetail: "ssssssssssssss",
    //         sColor: "#FFDCA9",
    //     },
    //     {
    //         nLogID: 8,
    //         sTitle : "วันที่ 25/08/2023 เวลา 11.20 น. ดำเนินการ ส่งกลับแก้ไข โดย ชื่อคนอนุมัติ (ตำแหน่ง)",
    //         sDetail: "ssssssssssssss",
    //         sColor: "#FFDCA9",
    //     },
    //     {
    //         nLogID: 9,
    //         sTitle : "วันที่ 28/08/2023 เวลา 11.20 น. ดำเนินการ ไม่อนุมัติ โดย แสดงชื่อผู้ที่ยกเลิกคำขอ (ตำแหน่ง)",
    //         sDetail: " - ",
    //         sColor: "#D0BFFF",
    //     }, 
    //     {
    //         nLogID: 10,
    //         sTitle : "วันที่ 25/08/2023 เวลา 11.20 น. ดำเนินการ ส่งคำขอ โดย ชื่อคนที่ขอลา (ตำแหน่ง)",
    //         sDetail: "ssssssssssssss",
    //         sColor: null,
    //     },
    //     {
    //         nLogID: 11,
    //         sTitle : "วันที่ 25/08/2023 เวลา 11.20 น. ดำเนินการ อนุมัติ โดย ชื่อคนอนุมัติ (ตำแหน่ง)",
    //         sDetail: "ssssssssssssss",
    //         sColor: "#BCE29E",
    //     },
    //     {
    //         nLogID: 12,
    //         sTitle : "วันที่ 28/08/2023 เวลา 11.20 น. ดำเนินการ ยกเลิกคำขอ โดย แสดงชื่อผู้ที่ยกเลิกคำขอ (ตำแหน่ง)",
    //         sDetail: " - ",
    //         sColor: "#FF9F9F",
    //     }      
    // ]);

    useEffect(() => {
        if (props.nRefID) {
            setnRefID(props.nRefID);
            GetLogHistoryLeave(props.nRefID);
        }
    }, [props.nRefID]);

    const GetLogHistoryLeave = (nRefID) => {
        let objParam = {
            nRefID: Convert.StringToInt(nRefID),
            nMode: props.nMode,
        }
        AxiosFn.Get(ApiLeave.GetLogHistory, objParam, (result) => {
            setlstDetailsLogHistory(result.lstDetailsLogHistory ?? []);
        });
    }

    //#region Page All      
    const PER_PAGE = 5;
    let [page, setPage] = useState(1);
    const count = Math.ceil(lstDetailsLogHistory.length / PER_PAGE);
    const _DATA = usePagination(lstDetailsLogHistory, PER_PAGE);

    const handleChange = (e, p) => {
        setPage(p);
        _DATA.jump(p);
    };

    const pageNext = () => {
        return <>{`${I18n.SetText("Leave.sNext")}`}</>;
    };

    const pagePrevious = () => {
        return <>{`${I18n.SetText("Leave.sPrevious")}`}</>;
    };
    //#endregion

    return (
        <Grid item container xs={12} md={12} spacing={1} style={{ paddingBottom: '1%', }}>
            <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                <Grid item className='div-breadcrumbs-Leave'>
                    <Typography variant="h6" style={{ fontSize: 'large', }}>{`${I18n.SetText("Leave.sOperationHistory")}`}</Typography> 
                </Grid>
            </Grid>
            <Grid item xs={12} md={12}>
                {_DATA.currentData().length > 0 ?
                    <>
                        <Grid item container spacing={2} xs={12} md={12} direction="row" justifyContent={"center"} alignItems={"center"} style={{ paddingLeft: '0px' }}>
                            {(_DATA.currentData()).map((iLogHistory, index) => {
                                let _sColor = iLogHistory.sColor ?? "#bbbbbb"; 
                                // nStatusID sStatusName 
                                //     1     รอ ผอ.ส่วน อนุมัติ
                                //     2     รอ ผอ.กอง อนุมัติ
                                //     3     อนุมัติคำขอ
                                //     4     ผอ.ส่วน ส่งกลับแก้ไข
                                //     5     ผอ.กอง ส่งกลับแก้ไข
                                //     6     รอ ผอ.ส่วน ไม่อนุมัติ
                                //     7     รอ ผอ.กอง ไม่อนุมัติ
                                //     8     ยกเลิกคำขอ
                                switch(iLogHistory.nStatusID)
                                {
                                    case 1: 
                                    case 2: 
                                        _sColor = EnumColorStatusHistory.SendRequest;
                                        break;
                                    case 4: 
                                    case 5: 
                                        _sColor = EnumColorStatusHistory.SendEdit;
                                        break;
                                    case 3: 
                                        _sColor = EnumColorStatusHistory.Approve;
                                        break;
                                    case 6: 
                                    case 7:
                                        _sColor = EnumColorStatusHistory.Reject;
                                        break;
                                    case 8: 
                                        _sColor = EnumColorStatusHistory.Cancel;
                                        break;
                                }

                                return (
                                    <Grid item xs={12} style={{ borderBottom: "10%" }} key={"LogHistory_" + iLogHistory.nLogID + "_" + index}>
                                        <AccordionCustom
                                            header={iLogHistory.sTitle}
                                            isExpanded={false}
                                            color="#0a0a0a"
                                            bgColor="rgb(102,151,245)"
                                            background={_sColor}
                                            expandIconColor="rgb(112 112 112)"
                                            borderColor="white"
                                            borderRadius="20px !important"
                                            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                                            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
                                        >
                                            <Grid item xs={12} md={12}>
                                                <Typography variant="body1" >{`${I18n.SetText("Leave.sComment")}` + iLogHistory.sComment}</Typography> 
                                            </Grid>
                                        </AccordionCustom>                                        
                                    </Grid>
                                );        
                            })}
                        </Grid>
                        <Grid item xs={12}>
                            <Stack spacing={2} style={{ margin: "1rem auto 2rem", alignItems: "center" }}>
                                <Pagination
                                    count={count}
                                    page={page}
                                    onChange={handleChange}
                                    color="primary"
                                    renderItem={(item) => <PaginationItem components={{ previous: pagePrevious, next: pageNext }} {...item} />}
                                />
                            </Stack>
                        </Grid>
                    </>
                : 
                    <Grid item container spacing={2} xs={12} md={12} style={{ textAlign: 'center' }}>
                        <Grid item xs={12} md={12}>
                            <Card style={{ backgroundColor: "rgb(245 245 245)" }}>
                                <Typography style={{ margin: "3%" }}>{`${I18n.SetText("Leave.sNoInformation")}`}</Typography>
                            </Card>
                        </Grid>
                    </Grid>
                }
            </Grid>                
        </Grid>
    )
}
export default LogHistory;